export enum restaurantsTypesEnum {
  RESTAURANTS_FAILURE = 'RESTAURANTS_FAILURE',
  SET_RESTAURANTS = 'SET_RESTAURANTS',
  RESTAURANTS_REQUEST = 'RESTAURANTS_REQUEST',
}
